export default "__VITE_ASSET__3s3ivXnE__"